const apiMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'TEST_EVENT':
      next(action);
      break;

    default:
      next(action);
  }
};

export default apiMiddleware;
